// Copyright ©️ 2026 eVolve MEP, LLC

import type { ShopConfiguration, WorkCell } from '@evolvemep/api-ts';

import { GridMenu } from 'components/Mantine/GridMenu';

import { useWorkCellSetupModals } from './modalRegistries';

type Props = {
  canDelete: boolean;
  shopConfiguration: ShopConfiguration;
  workCell: WorkCell;
  workCellUpdated: (workCell: WorkCell) => void;
  onWorkCellDeleted: () => void;
};

export const EditWorkCellMenu = ({
  shopConfiguration,
  workCell,
  workCellUpdated,
  onWorkCellDeleted,
  canDelete,
}: Props) => {
  const { openModal } = useWorkCellSetupModals();
  return (
    <GridMenu
      options={[
        'Edit',
        {
          value: 'Delete',
          hidden: !canDelete,
        },
      ]}
      onMenuItemSelected={(menuItemSelected) => {
        if (menuItemSelected === 'Edit') {
          openModal('createEditWorkCellModal', { shopConfiguration, workCell, onWorkCellSaved: workCellUpdated });
        } else {
          openModal('deleteWorkCellModal', { workCell, onWorkCellDeleted });
        }
      }}
    />
  );
};
